<template>
    <section id="publicaciones">
        <div class="container">
            <h2 class="pb-2">{{ titulo != null ? titulo : this.title != null ? this.title : '' }}</h2>

            <div v-if="!items" class="row row-cols-1 g-4"
                :class="[columnas > 0 ? 'row-cols-md-' + columnas : 'row-cols-md-3']">
                <div class="col" v-for="n in (parseInt(columnas) > 0 ? parseInt(columnas) : 3)" :key="n">
                    <div class="card loading-card-second">
                        <div class="card-body rounded d-flex align-items-center"></div>
                    </div>
                </div>
            </div>

            <div v-else class="row row-cols-1 g-4 text-center"
                :class="[columnas > 0 ? 'row-cols-md-' + columnas : 'row-cols-md-3']">
                <div class="col" v-for="(el, i) in items" :key="i">
                    <div class="card text-bg-ptn-color-gsj-brand position-relative" @mouseenter="openDropdownIndex = i"
                        @mouseleave="openDropdownIndex = null">
                        <div class="card-body">
                            <h3 class="my-0 fs-5">
                                <a v-if="el.url" :href="el.url" :target="el.target || '_self'"
                                    class="stretched-link text-reset">
                                    {{ el.title }}
                                </a>
                                <span v-else class="text-reset">{{ el.title }}</span>
                            </h3>
                        </div>

                        <transition name="fade-dropdown">
                            <ul v-if="el.links && el.links.length && openDropdownIndex === i"
                                class="dropdown-menu show mt-1" style="
      display: block;
      position: absolute;
      left: 0;
      top: 100%;
      z-index: 1000;
      width: 100%;
      white-space: normal;
      word-wrap: break-word;
      overflow-wrap: break-word;
      max-height: 250px;
      overflow-y: auto;
    ">
                                <li v-for="(link, index) in el.links" :key="index">
                                    <a class="dropdown-item" :href="link.url" :target="link.target || '_blank'">
                                        {{ link.title }}
                                    </a>
                                </li>
                            </ul>

                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
const axios = require('axios');

export default {
    name: "CardGridComponent",
    props: {
        titulo: String,
        subtitulo: String,
        columnas: String,
        filtros: Object,
        data: Object
    },
    data() {
        return {
            hash: "CGC",
            items: null,
            title: null,
            desc: null,
            openDropdownIndex: null
        };
    },
    mounted() {
        if (this.data == null) {
            let params = {};
            if (this.filtros != null && this.filtros !== "") {
                params = this.filtros;
            }
            params.tipo = this.hash;
            axios.post(process.env.VUE_APP_API_URL, params)
                .then(response => {
                    this.items = response.data ? response.data.items : null;
                    this.title = response.data ? response.data.title : null;
                    this.desc = response.data ? response.data.desc : null;
                    localStorage.setItem(this.hash, JSON.stringify(response));
                })
                .catch(error => {
                    if (!error.response) {
                        console.log("Fuera de Línea");
                        if (localStorage.getItem(this.hash)) {
                            console.log("Cargando elementos de cache para " + this.hash);
                            const resp = JSON.parse(localStorage.getItem(this.hash));
                            this.items = resp.data ? resp.data.items : null;
                            this.title = resp.data ? resp.data.title : null;
                            this.desc = resp.data ? resp.data.desc : null;
                        }
                    }
                });
        } else {
            this.items = this.data;
        }
    }
};
</script>

<style scoped>
.fade-dropdown-enter-active,
.fade-dropdown-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-dropdown-enter-from,
.fade-dropdown-leave-to {
    opacity: 0;
    transform: translateY(5px);
}

.fade-dropdown-enter-to,
.fade-dropdown-leave-from {
    opacity: 1;
    transform: translateY(0);
}

.dropdown-menu {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.375rem;
    background-color: white;
    padding: 0.5rem 0;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    font-size: 0.9rem;
    text-align: left;
}

.dropdown-item {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    padding: 0.5rem 1rem;
    line-height: 1.3;
}

.dropdown-item:hover {
    background-color: #f8f9fa;
}
</style>